import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  signal,
  WritableSignal
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseDialogDirective } from '../../../../../shared/components/base/base-dialog.directive';
import {
  ButtonSize,
  ButtonStyle
} from '../../../../../shared/enums/button.enum';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { DialogWrapperComponent } from '../../../../../shared/components/wrappers/dialog-wrapper/dialog-wrapper.component';
import { InputAddressComponent } from '../../../../../shared/components/controllers/input-address/input-address.component';
import { WooCommerceDeliveryAddress } from '../../../../../core/interfaces/woo-commerce/api/woo-commerce-api.interface';
import { CheckboxComponent } from '../../../../../shared/components/controllers/checkbox/checkbox.component';

export interface CheckoutAddDeliveryAddressDialogResult {
  address: WooCommerceDeliveryAddress;
  isDefault: boolean;
}

@UntilDestroy()
@Component({
  selector: 'app-checkout-add-delivery-address-dialog',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    DialogWrapperComponent,
    InputAddressComponent,
    CheckboxComponent
  ],
  templateUrl: './checkout-add-delivery-address-dialog.component.html',
  styleUrl: './checkout-add-delivery-address-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutAddDeliveryAddressDialogComponent
  extends BaseDialogDirective<CheckoutAddDeliveryAddressDialogResult | null>
  implements OnInit
{
  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonStyle = ButtonStyle;

  checkDelivery: boolean = this.dialogData?.['checkDelivery'] ?? true;
  showPrimaryToggle: boolean = this.dialogData?.['showPrimaryToggle'] ?? false;
  primaryLabel: string = this.dialogData?.['primaryLabel'] ?? 'Make Primary';

  isDefaultControl: FormControl = new FormControl(false);
  selectedAddress: WritableSignal<WooCommerceDeliveryAddress | null> =
    signal<WooCommerceDeliveryAddress | null>(null);

  ngOnInit(): void {
    const deliveryAddress = this.dialogData?.deliveryAddress;
    if (deliveryAddress) {
      this.selectedAddress.set(deliveryAddress);
    }

    this.isDefaultControl.setValue(!!this.dialogData?.['isDefault']);
  }

  onSubmit(
    selectedAddress: WooCommerceDeliveryAddress | null = this.selectedAddress()
  ): void {
    if (!selectedAddress) {
      throw Error('Selected address is not defined');
    }

    this.closeDialog({
      address: selectedAddress,
      isDefault: !!this.isDefaultControl.value
    });
  }
}
